module.exports = __webpack_public_path__ + "img/finish.8bfae392.png";